import { Injectable } from '@angular/core';
import { EulaListSearchCriteria } from '../models/end-user-license-agreement.model';
import { EulaListStateModel } from './end-user-license-agreement-list.state';
import { EndUserLicenseAgreementEndpoint } from '../constants/end-user-license-agreement-endpoint';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EndUserLicenseAgreementListService {
  constructor(private http: WrapperHttpService) {}

  getEulaList(searchCriteria: EulaListSearchCriteria): Observable<EulaListStateModel> {
    const url =
      `${API_URL}${EndUserLicenseAgreementEndpoint.Base}${EndUserLicenseAgreementEndpoint.Version}?` +
      getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<EulaListStateModel>(url);
  }
}
